import {Component, Input, OnInit} from '@angular/core';
import {NavigationExtras, Router} from '@angular/router';
import {RewardModel} from 'src/app/core-logic/models/business/sub/reward/reward-model';

@Component({
  selector: 'app-reward',
  templateUrl: './reward.component.html',
  styleUrls: ['./reward.component.scss'],
})
export class RewardComponent implements OnInit {
  @Input() type: 'customer' | 'business' = 'customer';
  @Input() route: { commands: any[]; extras?: NavigationExtras } = {commands: []};
  @Input() isLocked = false;
  @Input() pointsRemaining: number = null;
  @Input() isSuspended = false;
  @Input() reward: RewardModel;
  @Input() showShadowBox = false;
  @Input() hideAvailableMessage = true;
  constructor(private router: Router) { }

  ngOnInit() {}

  goToRoute() {
      switch (this.type) {
        case 'business':
          this.router.navigate(this.route.commands, this.route.extras ?? {state: this.reward});
          break;
        case 'customer':
          if (!this.isLocked && !this.isSuspended) {
            this.router.navigate(this.route.commands, this.route.extras ?? {state: this.reward});
          }
          break;
      }
  }
}
